/** Nom du pays pour l’API ville (liste pays + id sélectionné). */
export function countryNameForZip(selectedCountryId, countryList) {
  if (!countryList?.length) return "";
  if (!(selectedCountryId && selectedCountryId > 0)) return "";
  const row = countryList.filter((data) => data?.country_id === selectedCountryId)[0];
  return row?.country_name ?? "";
}

export function shouldLookupCityByPostal(countryName, postalcode) {
  const country = String(countryName ?? "").trim();
  const zip = String(postalcode ?? "").trim();
  return country.length > 0 && zip.length > 0;
}

/** Corps POST `/api/external/city`. */
export function buildCityByPostalBody(countryName, postalcode) {
  return {
    country: countryName,
    postalcode,
  };
}
